import React from 'react';
import './Tabs.scss';


interface TabPropsBase {
	title: string;
	trailing?: JSX.Element,
	hidden?: boolean,
}


type TabProps = React.PropsWithChildren<TabPropsBase>;

function Tab(props: TabProps): JSX.Element {
	const {
        children
	} = props;

	return (<div className="tab__content">
                {children}
            </div>
	);
}

const MemoisedTab = React.memo(Tab);

export {MemoisedTab as Tab};
export type {TabProps};
export {Tab as TabType};